import { render } from "./EndGame.vue?vue&type=template&id=9336557e&scoped=true"
import script from "./EndGame.vue?vue&type=script&lang=js"
export * from "./EndGame.vue?vue&type=script&lang=js"

import "./EndGame.vue?vue&type=style&index=0&id=9336557e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9336557e"]])

export default __exports__